import React from 'react';
import { CardConfirmed, CardDenied, CardDuplicate, CardError } from '.';
import { CardProps  } from '.';
import { ServiceStatus } from '../../../../../hoc/constants/service.constants';


const CardService: React.FC<CardProps> = ({ status, service, data, next }) => {

	return (
		<div
			id={service.name}>
			{(status === ServiceStatus.confirmed || status === ServiceStatus.enrolled) && (
				<CardConfirmed
					status={status}
					service={service}
					data={data}
					next={next}
				/>
			)}
			{status === ServiceStatus.denied && <CardDenied />}
			{status === ServiceStatus.duplicated && <CardDuplicate />}
			{(status === ServiceStatus.error 
				|| status === ServiceStatus.timeout) && <CardError />
			}
		</div>
	);
}

export default CardService;